import videojs from 'video.js';

class HeroVideoModule {
    constructor(selector) {
        this.selector = selector;
        this.heroVideos = document.querySelectorAll(selector);
        this.initHeroVideo();
        window.addEventListener('resize', this.initHeroVideo.bind(this));
    }

    initHeroVideo() {
        this.heroVideos.forEach(heroVideo => {
            if (heroVideo && !heroVideo.player) { 
                let player = videojs(heroVideo, {
                    modalDialogs: false,
                    textTrackSettings: false,
                    errorDisplay: false
                });
                heroVideo.player = player; 
                this.updateVideo(player, heroVideo);
                this.videoEndedClass(player, heroVideo);
                this.videoSkip(player, heroVideo);
                this.videoReplay(player, heroVideo);
            }
        });
    }


    updateVideo(player, heroVideoElement) {
        const largeSourceElement = heroVideoElement.querySelector('[data-large-source]');
        const mediumSourceElement = heroVideoElement.querySelector('[data-medium-source]');
        const smallSourceElement = heroVideoElement.querySelector('[data-small-source]');

        const largeSource = largeSourceElement ? largeSourceElement.getAttribute('src') : '';
        const mediumSource = mediumSourceElement ? mediumSourceElement.getAttribute('src') : '';
        const smallSource = smallSourceElement ? smallSourceElement.getAttribute('src') : '';

        const screenWidth = window.innerWidth;

        let sourceURL = '';

        if (screenWidth <= 480) {
            sourceURL = smallSource;
        } else if (screenWidth <= 769) {
            sourceURL = mediumSource;
        } else {
            sourceURL = largeSource;
        }

        if (sourceURL) {
            player.src({ type: 'video/mp4', src: sourceURL });
        } else {
            console.error('Video source URL not found.');
        }
    }


    videoEndedClass(player) {
        const heroVideoElement = document.querySelector('[data-video-section]');

        if (document.querySelector('[data-video-start]') !== null) {
            player.on('timeupdate', function () {
                const currentTime = player.currentTime();
                if (currentTime > .5) {
                    heroVideoElement.classList.add('c-video-banner--completed');
                }
            });
        }

        if (document.querySelector('[data-video-middle]')) {
            player.on('timeupdate', function () {
                const currentTime = player.currentTime();
                if (currentTime >= player.duration() / 2) {
                    heroVideoElement.classList.add('c-video-banner--completed');
                }
            });
        }

        if (document.querySelector('[data-video-end]')) {
            player.on('timeupdate', function () {
                const currentTime = player.currentTime();
                if (currentTime >= player.duration()) {
                    heroVideoElement.classList.add('c-video-banner--completed');
                }
            });
        }
    }

    videoReplay(player) {
        const replayButton = document.querySelector('[data-video-replay]');
        const heroVideoElement = document.querySelector('[data-video-section]');
        const heroVideo = document.querySelector('[data-hero-video]');

        if (replayButton && heroVideoElement && heroVideo) {
            replayButton.addEventListener('click', (e) => {
                e.preventDefault();
                heroVideo.classList.remove('u-hide');
                heroVideoElement.classList.remove('c-video-banner--completed');
                player.currentTime(0);
                player.play();
            });
        }
    }

    videoSkip(player) {
        const skipButton = document.querySelector('[data-video-skip]');
        const heroVideoElement = document.querySelector('[data-video-section]');
        const heroVideo = document.querySelector('[data-hero-video]');

        if (skipButton && heroVideoElement && heroVideo) {
            skipButton.addEventListener('click', (e) => {
                e.preventDefault();
                heroVideo.classList.add('u-hide');
                heroVideoElement.classList.add('c-video-banner--completed');
                player.currentTime(player.duration());
            });
        }
    }
}

export default HeroVideoModule;
